<template>
    <div>
        <div class="container is-max-widescreen p-5">
            <template>
                <img src="/static/images/Logo.svg" alt="iys logo">
            </template>
            <div>
                <div class="columns pt-6 ">
                    <div class="column colMenu is-one-third has-background-white mr-5">
                        <p class="is-size-4 fw600">Sorun Giderme</p> 
                        <p class="fs16 pt-3"><a href="#menu1" class="linkStyle">Doğrulama kodunu nasıl alabilirim?</a></p>
                        <p class="fs16 pt-5"><a href="#qrKod" class="linkStyle">QR Kodunu tarayamıyor musunuz?</a></p>
                        <p class="fs16 pt-5"><a href="#menu3" class="linkStyle">Doğrulama kodu çalışmıyor</a></p>
                        <p class="fs16 pt-5"><a href="#menu4" class="linkStyle">Doğrulama kodumu nasıl sıfırlarım?</a></p>
                        <p class="fs16 pt-5"><a href="#menu5" class="linkStyle">Kurtarma koduna erişimim yok</a></p>
                    </div>
                    <div class="column colText has-background-white">
                       <p class="is-size-3 fw600 linkStyle">Doğrulama kodunu nasıl aktif edebilirim?</p>
                       <p class="colorBlack pt-2">İki aşamalı doğrulama kodunu kullanabilmeniz için telefonunuza “Google Authenticator” uygulamasını kurmanız ve aktif etmeniz gerekmektedir.</p>
                        <div>
                            <p class="fw600 fs16 pt40 linkStyle">1. Google Authenticator uygulamasını telefonunuza kurun</p>
                            <p class="colorBlack pt-1">Telefonunuzun işletim sistemine göre (<b>App Store</b> ya da <b>Google Play</b> )  “Google Authenticator” uygulamasını indirin ve telefonunuza kurulumunu yapın. </p>
                            <div class="pt-6">
                            <img class="pr40" src="/static/images/iyspanel-appstore-logo.png" alt="">
                            <img src="/static/images/iyspanel-googleplaystore-logo.png" alt="">
                            </div>
                        </div> 
                        <div class="pt-5">
                            <p class="fw600 fs16 pt-2 linkStyle">2. İndirdiğiniz uygulamayı açın</p>
                            <p class="colorBlack pt-1">Uygulamayı açtıktan sonra karşınıza ilk kurulum ekranı çıkacaktır.  Burada “<b>QR kodunu tara</b>” seçeneğini seçerek devam ediyoruz. İşleme devam ettiğimizde uygulama içerisinde kameranız açılacak ve QR kodu taramaya hazır hale gelecektir. </p>
                            <div class="pt-6">
                            <img src="/static/images/iyspanel-ikiasamali-image-01.png" alt="">
                            </div>
                        </div>
                        <div class="pt-5">
                            <p class="fw600 fs16 pt-2 linkStyle">3. QR Kodu tarayın</p>
                            <p class="colorBlack pt-1">Telefonunuzu bilgisayarınızdaki tarayıcada açık halde duran QR koda doğru yaklaştırarak kodu tarayabilirsiniz. Kodu taradığınızda “<b>Google Authenticator</b>” uygulamasına yeni bir satır eklenecek ve 6 haneli doğrulama kodunu görebileceksiniz.</p>
                            <div class="pt-6">
                            <img src="/static/images/iyspanel-ikiasamali-image-02.png" alt="">
                            
                            </div>
                        </div>
                        <div class="pt-5">
                            <p class="fw600 fs16 pt-2 linkStyle">4. Doğrulama Kodunu İlgili Alana Yazın </p>
                            <p class="colorBlack pt-1">Google Authenticator 30 saniye boyunca kullanabileceğiniz bir kod üretir ve bu kod her 30 saniyeden sonra değişir. Uygulamanın ürettiği kodu 30 saniye içinde bilgisayarınızdaki tarayıcıda açık halde duran ekranda ilgili alana yazınız ve “<b>Doğrulama Kodunu Aktif Et</b>” butonuna basınız.  </p>
                            <div class="pt-6">
                            <img src="/static/images/iyspanel-ikiasamali-image-03.png" alt="">
                            
                            </div>
                        </div>
                        <div class="pt-5">
                            <p class="fw600 fs16 pt-2 linkStyle">5. İki aşamalı doğrulama kodunuz aktif edildi</p>
                            <p class="colorBlack pt-1">Doğrulama kodunuzun aktif edildiğine dair bir mesaj alırsınız.  Bu mesajı “<b>Tamam</b>” butonuna basarak onaylayabilirsiniz. Onayınızın ardından İYS Panel kontrol paneline yönlendirileceksiniz.</p>
                        </div>
                       
                        <div class="pt100" id="qrKod">
                            <p class="is-size-3 fw600 linkStyle" >Barkodu tarayamıyor musunuz?</p>
                            <p class="colorBlack pt-2">Google Authenticator uygulaması ile QR kodunu tarayamıyorsanız, Kurtarma kodunu kullanarak İki Aşamalı Doğrulama Kodunu aktif edebilirsiniz. Kurtarma kodu ile aktif edebilmeniz  için;</p>
                            <p class="fw600 fs16 pt40 linkStyle">1. Kurtarma kodunu girerek doğrulama anahtarını kurun</p>
                            <p class="colorBlack pt-1">Google Authenticator uygulamasını açın. Daha önce herhangi bir doğrulama kodunu aktif etmediyseniz “<b>Kurulum anahtarı gir</b>” seçeneğini dokunun.  Daha önceden kullanmış olduğunuz bir kod varsa yeni bir kod eklemek için ( <b>+</b> ) tuşuna basın ve “<b>Kurulum anahtarı gir</b>” seçeneğini seçin.</p>
                            <div class="pt-6">
                            <img src="/static/images/iyspanel-ikiasamali-image-04.png" alt="">
                            </div>
                        </div>
                        <div class="pt-5">
                            <p class="fw600 fs16 pt-2 linkStyle">2. Gerekli bilgileri girin</p>
                            <p class="colorBlack pt-1">Hesap adınızı belirlemek için “<b>Hesap adı</b>”  kısmını doldurun. (Örn.İYS Panel yazın)  “Anahtarınız” kısmına bilgisayar ekranında görünen “<b>Kurtarma Kodu</b>” kısmında yer alan 16 haneli kodu yazın.  Anahtar türü “<b>Zaman bazlı</b>” olarak bırakın ve  ardından “<b>Ekle</b>” tuşuna basın. Sonrasında uygulama içinde  doğrulama kodunu görebilirsiniz.</p>
                            <div class="pt-6">
                            <img src="/static/images/iyspanel-ikiasamali-image-05.png" alt="">
                            </div>
                        </div>
                        <div class="pt-5">
                            <p class="fw600 fs16 pt-2 linkStyle">3. Doğrulama Kodunu İlgili Alana Yazın</p>
                            <p class="colorBlack pt-1">Google Authenticator 30 saniye boyunca kullanabileceğiniz bir kod üretir ve bu kod her 30 saniyeden sonra değişir. Uygulamanın ürettiği kodu 30 saniye içinde bilgisayarınızdaki tarayıcıda açık halde duran ekranda ilgili alana yazınız ve “<b>Doğrulama Kodunu Aktif Et</b>” butonuna basınız. </p>
                            <div class="pt-6">
                            <img src="/static/images/iyspanel-ikiasamali-image-06.png" alt="">
                            </div>
                        </div>
                        <div class="pt-5">
                            <p class="fw600 fs16 pt-2 linkStyle">4. İki aşamalı doğrulama kodunuz aktif edildi</p>
                            <p class="colorBlack pt-1">Doğrulama kodunuzun aktif edildiğine dair bir mesaj alırsınız.  Bu mesajı “Tamam” butonuna basarak onaylayabilirsiniz. Onayınızın ardından İYS Panel kontrol paneline yönlendirileceksiniz.</p>
                        </div>
                        
                        <div class="pt100" id="menu3">
                            <p class="is-size-3 fw600 linkStyle">Doğrulama Kodu Çalışmıyor</p>
                            <p class="colorBlack pt-2">Google Authenticator’un ürettiği doğrulama kodları ile İYS Panel’e giriş yapamıyorsanız uygulama içinde ve telefonunuzda bazı ayarlamalar yapmanız gerekebilir. </p>
                            <p class="fw600 fs16 pt-5 linkStyle">Uygulamanın zaman ayarlarını senkronize edin</p>
                            <p class="colorBlack pt-1">Eğer İYS PANEL 2 aşamalı doğrulama kodu çalışmaz ise, “Google Authetnticator” uygulamasının ayar sayfasında yer alan senkronizasyonu çalıştırın. </p>
                            <div class="pt-4">
                            <img src="/static/images/iyspanel-ikiasamali-image-07.png" alt="">
                            </div>
                        </div>
                        <div class="pt-5">
                            <p class="fw600 fs16 pt-2 linkStyle">Telefonunuzun zaman ayarlarını kontrol edin</p>
                            <p class="colorBlack pt-1">Google Authenticator uygulamasının zaman ayarlarını senkronize etmenize rağmen doğrulama kodu çalışmıyor ise telefonunuzun saat ayarlarını kontrol edebilirsiniz. Telefonunuzun marka ve modeline göre saat ayarları farklı bir menü içinde olabileceği için bu ayarlara bularak kontrol ediniz. </p>
                        </div>
                        <div class="pt-5">
                            <p class="fw600 fs16 pt-2 linkStyle">Doğrulama Kodunu Sıfırlayın</p>
                            <p class="colorBlack pt-1">Tüm ayarları yapmanıza rağmen hala İYS  PANEL 2 aşamalı doğrulama kodu çalışmıyor ise Doğrulama Kodunu sıfırılayabilirsiniz. Doğrulama kodunu sıfırlama adımları için tıklayın. </p> 
                        </div> 
                        <div class="pt100" id="menu4">
                            <p class="is-size-3 fw600 linkStyle">Doğrulama Kodunu Nasıl Sıfırlarım?</p>
                            <p class="colorBlack pt-2">Google Authenticator uygulamasını telefonunuza yeniden kurduğunuzda, iki aşamalı doğrulama kodunu sildiğinizde ya da uygulamanın ürettiği doğrulama kodları ile İYS Panel’e giriş yapamadığınızda, 2 aşamalı doğrulama kodunu yeniden aktif etmeniz gerekecektir.  </p>
                        </div>
                        <div class="pt-5">
                            <p class="fw600 fs16 pt-2 linkStyle">Kurtarma Kodu ile Doğrulama Kodunu sıfırlama</p>
                            <p class="colorBlack pt-1">İYS PANEL’de 2 aşamalı doğrulamayı etkineştirdiğinizde size “<b>Kurtarma Kodu</b>” sunulmuş ve bu kodun güvenliğini sağlamanız istenmiştir. Eğer bu koda sahipseniz doğrulama kodunuzu kendiniz kolaylıkla sıfırlayabilirsiniz.</p>
                        </div>
                        <div class="pt-5">
                            <p class="fw600 fs16 pt-2 linkStyle">1. Google Authenticator uygulamasını açın</p>
                            <p class="colorBlack pt-1">Google Authenticator uygulamasını yeni kurduysanız  ilk hesap oluşturma ekranında “<b>Kurulum anahtarı gir</b>” seçeneğini seçin. Yeni bir doğrulama kodu eklemek isterseniz ise  uygulamada sağ alt köşede yer alan ( + ) tuşuna basın ve “<b>Kurulum anahtarı gir</b>” seçeneğini seçin.</p>
                            <div class="pt-4">
                            <img src="/static/images/iyspanel-ikiasamali-image-04.png" alt="">
                            </div>
                        </div>
                        <div class="pt-5">
                            <p class="fw600 fs16 pt-2 linkStyle">2. Kurtarma Kodunu girin</p>
                            <p class="colorBlack pt-1">Kurulum anahtarı gir seçeneğini seçtikten sonra hesap adınızı belirlemek için “<b>Hesap adı</b>”  kısmını doldurun. (Örn. İYS Panel yeni kod yazın)  “<b>Anahtarınız</b>” kısmına bilgisayar ekranında görünen “<b>Kurtarma Kodu</b>” kısmında yer alan 16 haneli kodu yazın.  Anahtar türü “<b>Zaman bazlı</b>” olarak bırakın ve  ardından “<b>Ekle</b>” tuşuna basın. Böylece yeni doğrulama kodunu aktif etmiş olacaksınız. </p>
                            <div class="pt-4">
                            <img src="/static/images/iyspanel-ikiasamali-image-08.png" alt="">
                            </div>
                        </div>
                        <div class="pt-5" id="menu5">
                            <p class="fw600 fs16 pt-2 linkStyle">Kurtarma Kodu’na erişiminizin olmaması</p>
                            <p class="colorBlack pt-1">Kurtarma Koduna erişiminiz yoksa İYS Panel’e giriş yapabilmek için yeni bir “<b>Kurtarma Kodu</b>” almanız gerekecektir. Bunun için destek ekibimiz ile iletişime geçebilirsiniz. Hesap güvenliğiniz için sizden bazı doğrulama bilgileri istenebilir. Kimliğiniz doğrulandığında daha önce kullanmış olduğunuz 2 aşamalı doğrulama kodunuz sıfırlanacaktır. Sonrasında İYS Panel’e ilk giriş yaptığınızda yeni QR kodu ve Kurtarma kodunu kullanarak  2 aşamalı doğrulama kodunuzun aktif edebileceksiniz. </p>
                        </div>
                        <div class="pt-4 py-4 supportDiv">
                            <p class="supportDivHeader">İYS Panel Destek Hattı</p>
                            <p class="supportDivTel pt-2">0850 483 0 444</p>
                        </div>
        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoginHeader from './LoginHeader';
export default {
    name:"LoginTwoFactorHelp",
    components: {
        LoginHeader
    },
    data() {
        return {
            
        }
    }
}
</script>
<style scoped>
   .fw600{
       font-weight: 600;
   }
   .fs16{
       font-size: 19px;
   }
   .linkStyle{
       color: #09101D;
   }
   .colorBlack{
       color: #000000;
       font-size: 16px;
   }
   .pr40{
       padding-right: 40px;
   }
   .pt100{
       padding-top: 100px;
   }
   .pt40{
       padding-top: 40px;
   }
   .colMenu{
       max-width:348px ;
       height: 370px;
       padding-left: 27px;
       padding-top: 45px;
   }
   .colText{
       padding-top: 50px;
       padding-left: 24px;
   }
   .supportDiv{
       background-color: #0B63CE;
       border-radius: 8px;
       margin-top: 20px;
       margin-bottom: 24px;
   }
   .supportDivHeader{
       color: #FFFFFF;
       font-weight: 600;
       font-size: 24px;
       line-height: 20px;
       text-align: center;
   }
   .supportDivTel{
       color: #FDCC4A;
       font-weight: 600;
       font-size: 24px;
       line-height: 20px;
       text-align: center;
   }
</style>



// WEBPACK FOOTER //
// src/components/LoginTwoFactorHelp.vue